<div class="d-flex justify-content-between align-items-center">
	<h5 class="d-flex align-items-center my-4 fw-bold">
		<i class="display-6 me-2 fa-solid fa-hourglass"></i> Historia zmian
	</h5>
	<button mat-button class="h-100 py-1" [disabled]="disableHTMLClose" [mat-dialog-close]="false" cdkFocusInitial>
		<i class="fs-3 fas fa-times"></i>
	</button>
</div>
<table mat-table [dataSource]="dataSource">
	<ng-container matColumnDef="publication">
		<th mat-header-cell *matHeaderCellDef>Publikacja</th>
		<td mat-cell *matCellDef="let element">{{ element.createdAt.date }} ({{ element.createdAt.time }})</td>
	</ng-container>

	<ng-container matColumnDef="date">
		<th mat-header-cell *matHeaderCellDef>Obowiązuje od</th>
		<td mat-cell *matCellDef="let element">{{ element.dateFrom.date }} ({{ element.dateFrom.time }})</td>
	</ng-container>

	<ng-container matColumnDef="price">
		<th mat-header-cell *matHeaderCellDef>Cena katalogowa</th>
		<td mat-cell *matCellDef="let element">{{ element.price | price }} PLN</td>
	</ng-container>
	<ng-container matColumnDef="isActive">
		<th mat-header-cell *matHeaderCellDef>Aktywny</th>
		<td mat-cell *matCellDef="let element">
			<i
				[ngClass]="{
					'fa-clock': element?.isActive === 'W',
					'fa-archive grey': !element.isActive,
					'fa-circle-check green': element?.isActive === 'T',
				}"
				class="fa-solid"
			></i>
		</td>
	</ng-container>
	<ng-container matColumnDef="author">
		<th mat-header-cell *matHeaderCellDef>Autor</th>
		<td mat-cell *matCellDef="let element">{{ element?.createdBy.firstName }} {{ element?.createdBy.lastName }}</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="columns"></tr>
	<tr mat-row *matRowDef="let row; columns: columns"></tr>
</table>
